import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class ModuloExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return left % right;
    }
}
//# sourceMappingURL=ModuloExpression.js.map